<template>
  <li class="nav-item dropdown dropdown-services">
    <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
      <fa :icon="fas.faTh"/>
    </a>
    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
      <vuescroll :ops="vuescroll_ops" style="height:360px;">
        <div class="service-search">
          <input
            type="text"
            name="search"
            v-model="search"
            class="form-control"
            :placeholder="$t('label.search')"
          >
        </div>
        <div
          v-for="item in items"
          :key="item.id"
          v-show="$hasPermissionOf(item.permission) && item.code != currentAppCode && !item.isHide"
        >
          <a :href="link(item)" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
              <service-icon size="40px" :src="item.content" :color="item.color"></service-icon>
              <div class="media-body">
                <h3 class="dropdown-item-title">{{ itemName(item) }}</h3>
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
        </div>
        <div v-if="user && inAdmin(user) && currentAppCode != 'admin_dashboard'">
          <a :href="adminDashboardUrl" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
              <service-icon
                size="40px"
                :src="require(`../assets/images/svg/admin_dashboard.svg`)"
                color="#567C73"
              ></service-icon>
              <div class="media-body">
                <h3 class="dropdown-item-title">{{ $t('label.admin_dashboard') }}</h3>
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
        </div>
      </vuescroll>
      <a :href="appDashboardLink" class="dropdown-item dropdown-footer">
        <fa :icon="fas.faTh"/>
        {{ $t('label.app_dashboard') }}
      </a>
    </div>
  </li>
</template>

<script>

import ServiceIcon from "@/components/ServiceIcon.vue";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { mapState } from "vuex";
import vuescroll from "vuescroll";
export default {
  name: "LocaleChanger",
  props: {
    currentAppCode: {
      type: String,
      default: null
    }
  },
  components: {
    ServiceIcon,
    vuescroll
  },
  data() {
    return {
      items: [],
      search: "",
      vuescroll_ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          onlyShowBarOnScroll: false,
          background: "#000000",
          opacity: 0.5
        }
      }
    };
  },
  watch: {
    search: {
      handler: function(val) {
        this.items.forEach(function(item) {
          if (
            item.name_en.toLowerCase().includes(val.toLowerCase()) ||
            item.name_kh.toLowerCase().includes(val.toLowerCase())
          ) {
            item.isHide = false;
          } else {
            item.isHide = true;
          }
        });
      },
      deep: true
    }
  },
  computed: {
	fas() {
		return fas;
	},
    appDashboardLink() {
      const url = process.env.VUE_APP_USER_DASHBOARD_URL;
      const appPrefix = process.env.VUE_APP_PREFIX;
      const cipherToken = localStorage.getItem(appPrefix + "token");
      return url + `?token=${encodeURIComponent(cipherToken)}`;
    },
    adminDashboardUrl() {
      const base_url = process.env.VUE_APP_ADMIN_DASHBOARD_URL;
      const appPrefix = process.env.VUE_APP_PREFIX;
      const cipherToken = localStorage.getItem(appPrefix + "token");
      return base_url + `?token=${encodeURIComponent(cipherToken)}`;
    },
    ...mapState("user", ["user"])
  },
  mounted() {
    this.getList();
    this.initDropdown();
  },
  methods: {
    getList() {
      GDCE_Client.requestApi("GET", "services").then(
        result => {
          this.items = result.data;
        },
        () => {}
      );
    },
    initDropdown() {
      window.$(".dropdown-services").on("shown.bs.dropdown", function(event) {
        window.$(event.relatedTarget)
          .parent()
          .find("input[name=search]")
          .focus();
      });
    },
    link(item) {
      if (!item.base_url || item.base_url == "#") {
        return "#";
      }

      const appPrefix = process.env.VUE_APP_PREFIX;
      const cipherToken = localStorage.getItem(appPrefix + "token");

      // url for version 1
      if (item.version == "1") {
        var protocol = item.base_url.split(/[/?#]/)[0];
        var domain = item.base_url
          .replace("http://", "")
          .replace("https://", "")
          .split(/[/?#]/)[0];
        var url = protocol + "//" + domain;
        var uri = item.base_url.replace(url, "");
        return (
          url +
          "/v2/login?token=" +
          encodeURIComponent(cipherToken) +
          "&redirect=" +
          encodeURIComponent(uri)
        );
      }

      return item.base_url + `?token=${encodeURIComponent(cipherToken)}`;
    },
    itemName(item) {
      const local = localStorage.getItem("locale");
      if (local == "en") {
        return item.name_en;
      } else {
        return item.name_kh;
      }
    },
    inAdmin(user) {
      // console.log(user.data);
      const roles = user.data.roles;
      return roles.indexOf("Administrator") != -1;
    }
  }
};
</script>
<style lang="scss" scoped>
.media-body {
  padding-top: 10px;
  padding-left: 5px;
}
.dropdown-footer {
  -webkit-box-shadow: 0 -3px 10px -5px rgba(0, 0, 0, 0.5);
  box-shadow: 0 -3px 10px -5px rgba(0, 0, 0, 0.5);
}
.service-search {
  padding: 15px 15px 5px 15px;

  > input {
    -webkit-border-radius: 50px;
    border-radius: 50px;
  }
}
</style>
